<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('topics.editDeadline')"></page-title>
    </div>

    <jet-form-section @submitted="updateDeadline()">

        <template #form>
            <!-- Card Deadline -->
            <form-card :title="$t('topics.deadline')" :description="$t('topics.deadlineDescription')">

                <div class="col-span-3">
                    <label for="deadline" class="block text-sm font-medium text-gray-700">{{
                            $t("topics.deadline")
                        }}</label>
                    <div class="flex">
                        <div class="mt-1 flex minplan-std-inputheight">
                            <span
                                class="inline-flex items-center px-3 border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                                <CalendarIcon class="h-5 w-5 text-minplan-darkgreybeige" id="deadline" />
                            </span>
                            <Calendar v-model="form.deadline"
                                      dateFormat="dd.mm.yy"
                                      :manual-input="true"
                                      class="focus:ring-minplan-blue focus:border-minplan-blue" />
                        </div>
                    </div>
                    <jet-input-error :message="form.errors.deadline" class="mt-2" />
                </div>

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button"
                        class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>
            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import { CalendarIcon } from "@heroicons/vue/outline";
import moment from "moment";

export default defineComponent({
    props: ["apartment", "topic"],
    inheritAttrs: false,
    emits: ["closeModal", "reloadTopics"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        CalendarIcon
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        updateDeadline() {
            if (this.form.deadline) {
                this.form.deadline = moment(this.form.deadline, "DD.MM.YYYY").format();
            }
            this.form.put(this.route("advisors.topics.update", { apartment: this.apartment.uuid, topic: this.topic }), {
                preserveScroll: true,
                onSuccess: () => {
                    this.$notify({
                        group: "success",
                        title: "actions.success",
                        text: "topics.updated"
                    });

                    this.$emit("reloadTopics");
                }
            });
        },
        }, setup(props) {
            const form = useForm({
                deadline: props.topic.deadline
            });

            return { form };
        }
    });
</script>

<style scoped></style>
